const getDefaultState = () => {
  return {
    firmImageUrl: null,
    firmImageId: null,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasFirmImage: (state) => {
      return !!state.firmImageUrl && !!state.firmImageId;
    },
    getFirmImageUrl: (state) => state.firmImageUrl,
    getFirmImageId: (state) => state.firmImageId,
  },
  mutations: {
    SET_FIRM_IMAGE_URL(state, firmImageUrl) {
      state.firmImageUrl = firmImageUrl;
    },
    SET_FIRM_IMAGE_ID(state, firmImageId) {
      state.firmImageId = firmImageId;
    },
  },
  actions: {
    setFirmImage({ commit }, firmImageUrl) {
      commit("SET_FIRM_IMAGE_URL", firmImageUrl);
    },
    setFirmImageId({ commit }, firmImageId) {
      commit("SET_FIRM_IMAGE_ID", firmImageId);
    },
    clearFirmImage({ commit }) {
      commit("SET_FIRM_IMAGE_URL", "");
    },
  },
};
